.secondary-row
    a.btn.btn-danger.pull-right(href='/reports/#{model.id}/csv') Export a CSV

.container
    .row
        .col-md-12
            .main-content
